'use strict';

jQuery(document).ready(function ($) {
  $.ajax({
    url: 'https://www.estadao.com.br/dados/portal/comum/tendencias/jornal-do-carro.json',
    type: 'GET',
    success: function success(response) {
      if (response) {
        var keys = Object.keys(response).filter(function (key) {
          return key.includes('txt_content');
        });
        response = keys.reduce(function (acc, cur) {
          return acc += response[cur] !== '' ? '<p>' + response[cur] + '</p>' : '';
        }, '');
        $('#trending-posts-list').html(response);
        $('#trending-posts').css('display', 'block');
      }
    }
  });
});